// extracted by mini-css-extract-plugin
export default {"stepHeadStyle":"StepHeader_stepHeadStyle__V95pi"};